var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('next-steps-base-card',{attrs:{"title":"להשלים את הצעדים הראשונים לשימוש בתזרים","button-text":"לרשימת הצעדים","description":"15 דקות","action-key":_vm.actionKey},on:{"click":_vm.openActionsList}})}
var staticRenderFns = []

export { render, staticRenderFns }